module.exports = __webpack_public_path__ + "img/舞阳县-c.90819170.png";